import { render } from "./AddProductDialog.vue?vue&type=template&id=4578bc20&scoped=true"
import script from "./AddProductDialog.vue?vue&type=script&lang=js"
export * from "./AddProductDialog.vue?vue&type=script&lang=js"

import "./AddProductDialog.vue?vue&type=style&index=0&id=4578bc20&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4578bc20"]])

export default __exports__